import React from "react";
import { DataTable, LineChart } from "react-library";
import { TDataset, TTableData } from "../types";
import { TVisualization } from "./ChartOptionsIcons";

type TProps = {
  datasets: Array<TDataset>;
  chartId: string;
  timestamps: Array<string>;
  tableColumns: Array<string>;
  active: TVisualization;
  tableData: TTableData
}

const ColumnsWidth: Record<number, Array<number>> = {
  1: [329],
  2: [200, 129],
  3: [170, 80, 79],
  4: [115, 71, 72, 71]
};

const DataVisualizationRenderer: React.FC<TProps> = (props) => {
  const { datasets, chartId, timestamps, active, tableData, tableColumns } = props;
  return (
    <div className="flex content-center">
      {datasets.length > 0 && timestamps.length && (
        <LineChart
          key={chartId}
          datasets={datasets}
          labels={timestamps}
          style={{
            display: active === "graph" ? "block" : "none"
          }}
        />
      )}

      <DataTable 
        columns={tableColumns}
        data={tableData}
        style={{ display: active === "table" ? "block" : "none" }}
        tableStyles={{ height: "500px" }}
        columnWidths={ColumnsWidth[tableColumns.length]}
      />
    </div>
  );
};

export default DataVisualizationRenderer;




//??: this is an old code 